import { isRejectedWithValue, type Middleware } from '@reduxjs/toolkit';
import { baseApi } from '@store/baseApi';

import { setAuthState, setAuthStatus } from './slice';

/**
 * Middleware to handle authentication errors from API calls.
 * Sets unauthorized state when receiving 401/403 errors.
 * Distinguishes membership deactivation (403 with MEMBERSHIP_DEACTIVATED)
 * from generic permission errors.
 */
export const userAuthErrorMiddleware: Middleware = store => next => action => {
  // Only smartscribe-server errors govern this app's authentication state.
  if (isRejectedWithValue(action) && action.type.startsWith(`${baseApi.reducerPath}/`)) {
    const payload = action.payload as { status?: number; data?: unknown } | undefined;

    if (payload?.status === 401) {
      store.dispatch(setAuthState({ unauthorized: true }));
    } else if (payload?.status === 403) {
      // Check for membership deactivation error code from the API response body.
      // auth0BaseQuery wraps errors as { status, data: { status, data: <original body>, message } }
      const errorData = payload.data as { data?: { error_code?: string } } | undefined;
      if (errorData?.data?.error_code === 'MEMBERSHIP_DEACTIVATED') {
        store.dispatch(setAuthStatus('membership_deactivated'));
      } else {
        store.dispatch(setAuthState({ unauthorized: true }));
      }
    }
  }

  return next(action);
};
